import React from "react";
//style="{{min-width:120px;}}"
export const OnClickButton = props => <button className="btn btn-main mt-1 md-md-0 ml-md-1 mb-md-h btn-xxs-block" onClick={props.onClick} id={props.id} value={props.value} name={props.name}>{props.title}</button>
